import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";

import AuthModal from "@components/Authmodal/AuthModal";
import Footer from "@components/footer/Footer";
import Header from "@components/header/Header";
import LoginModal from "@components/LoginModal/LoginModal";
import HomeBanner from "@components/shared/Banner/Banner";
import Loader from "@components/shared/Loader/Loader";
import MemberListing from "@components/User/MemberListing/MemberListing";
import PasswordModal from "@components/User/PasswordModal/PasswordModal";
import RegisterModal from "@components/User/RegisterModal/RegisterModal";
import { CONSTANTS } from "@constants/index";
import { routeEnum, supportEnum } from "@enums/route.enum";
import { useFirebaseNotification } from "@hooks/useFirebaseNotification/useFirebaseNotification";
import { MainLayoutProps } from "@models/utils/layout.model";
import API_SERVICES from "@services/index";
import authSlice from "@slices/auth.slice";
import bookingSlice from "@slices/booking.slice";
import modalSlice from "@slices/modal.slice";
import { RootState } from "@store/index";
import { isMobile } from "@utils/common.utils";

import "react-toastify/dist/ReactToastify.css";
const MainLayoutComponent = (props: MainLayoutProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const invitationToken = currentUrl.split("/").pop() ?? "";
  useEffect(() => {
    if (currentUrl.includes("auth/register/verify-email")) {
      dispatch(modalSlice.actions.updateLoginModal(true));
    } else if (currentUrl.includes("auth/register/verify-invitation")) {
      checkInvitationPageShow();
    } else if (currentUrl.includes("auth/register/reset-password")) {
      dispatch(modalSlice.actions.updatePasswordModal(true));
    } else if (!currentUrl.includes(supportEnum.Booking)) {
      dispatch(bookingSlice.actions.setPaymentLoader(false));
    }
  }, [currentUrl]);

  useFirebaseNotification();

  const { pathname } = useLocation();
  const { authModal, loginModal, memberListing, passwordModal, registerModal } =
    useSelector((State: RootState) => State.modal);
  const { paymentLoader } = useSelector((State: RootState) => State.booking);

  const checkIsBannerShow = () => {
    let isShow = true;
    if (
      (isMobile() &&
        (currentUrl?.includes(supportEnum.ContactPerson) ||
          currentUrl?.includes(supportEnum.UserInfo) ||
          currentUrl?.includes(supportEnum.Reservations) ||
          currentUrl?.includes(supportEnum.Member))) ||
      pathname.includes("/organisation-info")
    )
      isShow = false;

    return isShow;
  };

  const checkInvitationPageShow = async () => {
    const response =
      await API_SERVICES.USER.CHECK_INVITATION_PAGE_SHOW(invitationToken);

    // Check status code or message
    if (response?.status == CONSTANTS.HTTP_STATUS.NOT_FOUND) {
      navigate(`/${routeEnum.InvitationExpiry}`, {
        state: {
          message: response?.data?.message,
          text: response?.data?.text,
        },
      });
    } else {
      const profileId = response?.data?.profileId;

      if (profileId) {
        dispatch(authSlice.actions.setInvitationProfileId(profileId));
      }
      dispatch(modalSlice.actions.updateRegisterModal(true));
    }
  };

  return (
    <>
      {paymentLoader && currentUrl?.includes(supportEnum.Booking) && (
        <div className="fg-page-loader-wrap">
          <Loader isLoading={paymentLoader} />
        </div>
      )}
      <ToastContainer />
      <Header />
      {authModal && <AuthModal />}
      {loginModal && <LoginModal />}
      {memberListing && <MemberListing />}
      {registerModal && <RegisterModal />}
      {passwordModal && <PasswordModal />}
      {checkIsBannerShow() && <HomeBanner />}
      <main className="fg-main-wrapper">
        <div data-testid="mainLayoutChildren">{props.children}</div>
      </main>
      <Footer />
    </>
  );
};
const MainLayout = withTranslation()(MainLayoutComponent);
export default MainLayout;
